// Thin, safe wrapper over GTM's window.dataLayer for Air12 Phase-1 analytics.
// - No-ops safely outside a browser.
// - Enforces an allow-list of event names AND parameter keys (drops everything else).
// - Never throws; never blocks a user action.
// - Sends NO PII: unknown/disallowed params (name, email, phone, ids, amounts, etc.) are dropped.

const ALLOWED_EVENTS = new Set([
  "check_price_click",
  "estimate_form_start",
  "estimate_generated",
  "estimate_unavailable",
  "request_callback",
  "continue_to_booking",
  "track_shipment_click",
  "track_shipment_search",
  "login_click_google",
  "login_click_email",
  "phone_click",
]);

const ALLOWED_PARAMS = new Set([
  "page_path",
  "placement",
  "cta_name",
  "form_name",
  "route_code",
  "route_label",
  "source_airport",
  "destination_airport",
  "pickup_zone",
  "delivery_zone",
  "weight_band",
  "package_count_band",
  "load_assist_side",
  "estimate_available",
  "reason_code",
  "search_result",
  "auth_method",
]);

export function currentPagePath() {
  try {
    return window.location.pathname;
  } catch {
    return undefined;
  }
}

export function weightBand(kg) {
  const n = Number(kg);
  if (!Number.isFinite(n) || n <= 0) return "unknown";
  if (n < 50) return "under_50";
  if (n <= 100) return "50_100";
  if (n <= 250) return "101_250";
  if (n <= 500) return "251_500";
  if (n <= 1000) return "501_1000";
  return "1000_plus";
}

export function packageCountBand(count) {
  const n = Number(count);
  if (!Number.isFinite(n) || n <= 0) return "unknown";
  if (n === 1) return "1";
  if (n <= 5) return "2_5";
  if (n <= 10) return "6_10";
  return "11_plus";
}

export function pushEvent(eventName, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (!ALLOWED_EVENTS.has(eventName)) return;
    window.dataLayer = window.dataLayer || [];
    const clean = {};
    for (const [k, v] of Object.entries(params || {})) {
      if (!ALLOWED_PARAMS.has(k)) continue;      // drop disallowed / PII keys
      if (v === undefined || v === null || v === "") continue; // omit empties
      clean[k] = v;
    }
    window.dataLayer.push({ event: eventName, ...clean });
  } catch {
    // Never surface analytics errors to the user or block the action.
  }
}
